import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import { Page } from '@percent/workplace-giving/common/components/Layout/Page'
import classes from './Settings.module.scss'
import { CalendarIntegration } from './SettingsElements/CalendarIntegration/CalendarIntegration'
import { useAuth } from '@percent/workplace-giving/common/hooks'
import { getPartnerFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'
import { getAvailableProviders } from '@percent/workplace-giving/common/hooks/useIntegrateWithCalendar/calendarProvider.utils'
import { SecondaryEmail } from './SettingsElements/SecondaryEmail/SecondaryEmail'

export function Settings() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state } = useAuth()
  const partner = getPartnerFromAuthState(state)

  const canIntegrateWithCalendar = getAvailableProviders(partner?.calendarIntegration).length > 0
  const secondaryEmailEnabled = partner?.features?.profileSecondaryEmails === 'enabled'

  useEffect(() => {
    // todo: remove this condition in the future when more settings available and page is no longer empty without optional content
    if (!canIntegrateWithCalendar && !secondaryEmailEnabled) {
      navigate(AppRoute.HOME)
    }
  }, [canIntegrateWithCalendar, secondaryEmailEnabled, navigate])

  return (
    <Page fullWidthContent>
      <h2 className={classes.PageTitle}>{t('workplace_giving.navigation.settings')}</h2>
      <div className={classes.Wrapper}>
        {canIntegrateWithCalendar ? <CalendarIntegration /> : null}
        {secondaryEmailEnabled ? <SecondaryEmail /> : null}
      </div>
    </Page>
  )
}
